import * as React from 'react';
import styled from 'styled-components';
import {ColorEnum} from '../../enum/color.enum';
import {LINKED_IN_BACKGROUND_COLOR, LINKED_IN_LOGIN_ROUTE, LINKED_IN_LOGIN_STORAGE_KEY} from '../../constants';
import {ILinkedInLoginResponse} from '../../interface/component/linkedin-login-response.interface';
import {formLinkedInRedirectUri} from '../../util/string/form-linked-in-redirect-uri.util';
import {IInjectedProps} from '../../interface/component/injected-props.interface';
import {inject} from 'mobx-react';
import {joinUrl} from '../../util/url/join-url.util';
import {encodeQuery} from '../../util/url/encode-query.util';
import {getTranslation} from '../../util/translation/get-translation';
import {isStringEmpty} from '../../util/string/is-string-empty.util';
import {LinkedInIcon} from '../icons';
import {largeMobileMedia} from '../../util/style/large-mobile-media';
import {LOCAL_STORAGE_ENABLED} from '../../util/storage/storage';
import {PopupSizeEnum} from '../../enum/popup-size.enum';

interface IButtonWrapperProps {
  disabled?: boolean;
}

const ButtonWrapper = styled.div`
  background-color: ${LINKED_IN_BACKGROUND_COLOR};
  border-radius: 4px;
  color: ${ColorEnum.White};
  justify-content: space-evenly;
  align-items: center;
  cursor: ${(props: IButtonWrapperProps) => !props.disabled ? 'pointer' : 'wait'};
  padding: 22px 17px 22px 17px;
  text-transform: uppercase;
  max-width: 300px;
  display: inline-flex;
  height: 0px;

  &:hover {
    opacity: ${(props: IButtonWrapperProps) => !props.disabled ? 0.8 : 1};
  }
  ${largeMobileMedia(`
    max-width: 100%;
  `)}
`;

const ButtonIconWrapper = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 17px;
  & svg {
    width: 100%;
    height: 100%;
  }
`;

interface ILinkedinLoginButtonProps {
  loginText: React.ReactNode;
  disableAPI: boolean;
  clientId: string;
  onLogin: (response: ILinkedInLoginResponse) => void;
}

const getLinkedInAuthUrl = (clientId, scope, redirectUri) => {
  return 'https://www.linkedin.com/oauth/v2/authorization?' + encodeQuery({
    response_type: 'code',
    client_id: clientId,
    scope,
    redirect_uri: redirectUri
  });
};

@inject('state', 'dispatch', 'history')
export class LinkedinLoginButton extends React.Component<ILinkedinLoginButtonProps & IInjectedProps> {
  componentDidMount() {
    if (LOCAL_STORAGE_ENABLED && localStorage.getItem(LINKED_IN_LOGIN_STORAGE_KEY)) {
      const profile = JSON.parse(localStorage.getItem(LINKED_IN_LOGIN_STORAGE_KEY));
      localStorage.removeItem(LINKED_IN_LOGIN_STORAGE_KEY);
      this.onLogin(profile);
    }
  }

  onLoginClick = () => {
    const linkedInAuthUrl = getLinkedInAuthUrl(this.props.clientId,
      'r_liteprofile r_emailaddress',
      formLinkedInRedirectUri(
        joinUrl(this.props.state.configuration.CMSUrl, LINKED_IN_LOGIN_ROUTE),
        this.props.clientId, joinUrl(this.props.state.configuration.CMSUrl, this.props.history.location.pathname))
    );
    (window as any).setLinkedInData = this.onLogin;
    this.props.dispatch.openPopupWindow(
      linkedInAuthUrl,
      getTranslation(this.props.state.configuration, 'linked-in-auth.popup-title'),
      PopupSizeEnum.LARGE);
  }

  onLogin = profile => {
    if (this.props.onLogin) {
      this.props.onLogin(profile);
    }
    (window as any).setLinkedInData = undefined;
  }

  render() {
    return (
      <ButtonWrapper
        disabled={this.props.disableAPI || isStringEmpty(this.props.clientId)}
        onClick={this.onLoginClick}
      >
        <ButtonIconWrapper>
          <LinkedInIcon/>
        </ButtonIconWrapper>
        {this.props.loginText}
      </ButtonWrapper>
    );
  }
}
